const convertToDecimals = (num, decimals) => parseFloat(num).toFixed(decimals);

// allows 2 decimal places leading zero ie. 999.00 and replaces leading zeroes
const convertCoinAmountToDecimals = (num, decimals) =>
  convertToDecimals(num, decimals).replace(/(\.\d*?[0-9][0-9])0+$$/g, "$1");

export default {
  convertToDecimals,
  convertCoinAmountToDecimals,
};
